// ESM re-export of the CJS entry point.
// index.js remains the single source of truth.
import deselectCurrent from './index.js';
export default deselectCurrent;
